import { render, staticRenderFns } from "./FaqQuestionAnswer.vue?vue&type=template&id=8b8e5e24"
import script from "./FaqQuestionAnswer.vue?vue&type=script&lang=js"
export * from "./FaqQuestionAnswer.vue?vue&type=script&lang=js"
import style0 from "./FaqQuestionAnswer.vue?vue&type=style&index=0&id=8b8e5e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports